import { render, staticRenderFns } from "./DesignAssets.vue?vue&type=template&id=414f33c6&scoped=true"
import script from "./DesignAssets.vue?vue&type=script&lang=js"
export * from "./DesignAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414f33c6",
  null
  
)

export default component.exports